<div class="page-container">
  <!-- 搜索 -->
  <div class="main-container unity-padding-web unity-padding-h5-14">
    <div class="container" #seed appLifeObserve (lifeChange)="initBreakpoint($event, seed)">
      <div class="content-box search">
        <app-new-search-game></app-new-search-game>
      </div>
    </div>
  </div>

  <!-- 主体 -->
  <div class="main-container unity-padding-web unity-padding-h5-14">
    <div class="container">
      <div class="content-box main-list">
        <div class="tit">
          <app-breadcrumbs current="{{ 'all_rec' | translate }}"></app-breadcrumbs>
        </div>
        <div class="con">
          <!-- 有内容 或 loading -->
          <ng-container *ngIf="games.length > 0 || loading">
            <div class="item-content" style.grid-template-columns="repeat({{ breakpoint }},1fr)">
              <ng-container *ngIf="games.length > 0; else loadingTl">
                <app-game-unit *ngFor="let item of games" [item]="item"></app-game-unit>
              </ng-container>
              <ng-template #loadingTl>
                <div *ngFor="let item of breakpoint * 3 | arrayFromLength" class="skeleton-loading"></div>
              </ng-template>
            </div>
            <app-game-paginator
              (loadNext)="getRecentLyPlayedList(false)"
              [(page)]="paginator.page"
              [loading]="loading"
              [pageSize]="paginator.pageSize"
              [total]="paginator.total"
            >
            </app-game-paginator>
          </ng-container>
          <!-- 无内容且不是loading -->
          <app-empty *ngIf="games.length < 1 && !loading" [text]="'no_data' | translate"></app-empty>
        </div>
      </div>
    </div>
  </div>
</div>
